import { render, staticRenderFns } from "./Season.vue?vue&type=template&id=c56d5bde&"
import script from "./Season.vue?vue&type=script&lang=js&"
export * from "./Season.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports